import React, { Fragment, useState, useEffect, useRef, useMemo } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  Checkbox,
  TableBody,
  TableRow,
  tableCellClasses,
  CircularProgress,
  Dialog,
  Paper,
  TableCell,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  IconButton,
  InputAdornment,
  Tooltip,
  Button,
} from "@mui/material";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily, SearchIcon } from "assets";
import InputField from "components/Input";
import { CancelOutlined } from "@mui/icons-material";
import ClientServices from "services/Client";
import SystemServices from "services/System";
import { makeStyles } from "@mui/styles";
import styled from "@emotion/styled";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import Pagination from "components/Pagination";
import { useForm } from "react-hook-form";
import moment from "moment";
import EditNotes from "components/Dialog/EditNotes";
import { CommaSeparator, findDifferences, formatPermissionData } from "utils";
import { useNavigate } from "react-router-dom";
import CurrencyServices from "services/Currency";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useAuth } from "context/UseContext";
import CostingDialog from "components/Dialog/CostingDialog";
import DropdownMenu from "components/DropDown";
import { UploadFile } from "@mui/icons-material";
import MaximizeIcon from "@mui/icons-material/Maximize";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import DeleteIcon from "@mui/icons-material/Delete";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "normal",
    verticalAlign: "top",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    // textWrap: "nowrap",
    verticalAlign: "middle",
    whiteSpace: "normal",
    maxWidth: "200px",
    wordBreak: "break-word",
    padding: "3px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "3px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "5px",
      width: "24px",
      height: "24px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function ShippingCostingV2() {
  const navigate = useNavigate();
  const { usdExchangeRate, cadExchangeRate } = useSelector(
    (state) => state.navigationReducer,
  );
  const { user } = useAuth();
  // *For Client Dropdown
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState({});
  const [batchCounter, setBatchCounter] = useState(1);
  const [batchNumber, setBatchNumber] = useState("");
  const [totalSum, setTotalSum] = useState(0);

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState();
  const [activeMenu, setActiveMenu] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
  const [uploadHeaderMap, setUploadHeaderMap] = useState({});
  const [uploadTextHeaders, setUploadTextHeaders] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [pageLimits, setPageLimits] = useState(1000);
  const [isPrefetching, setIsPrefetching] = useState(false);
  const [isPrefetchComplete, setIsPrefetchComplete] = useState(false);
  const [prefetchProgress, setPrefetchProgress] = useState({
    done: 0,
    total: 0,
  });
  const [isUploading, setIsUploading] = useState(false);
  const prefetchAbortRef = useRef({ aborted: false });

  const [currentPage, setCurrentPage] = useState(1);

  const [clientCosting, setClientCosting] = useState([]);
  const [clientCostingData, setClientCostingData] = useState([]);
  const [copyClientCosting, setCopyClientCosting] = useState();
  const [selectedClientBooking, setSelectedClientBooking] = useState([]);
  const [excelDialogMax, setExcelDialogMax] = useState(false);
  //for table ID
  const [tableId, setTableId] = useState();

  const componentRef = useRef();

  // *for Button Disable
  const [disableButton, setDisableButton] = useState(false);

  // Old Array
  const [oldArray, setOldArray] = useState();

  const [showDue, setShowDue] = useState(true);

  // *For Total Amount
  const [totalAmount, setTotalAmount] = useState([]);
  const [oldTable, setOldTable] = useState(false);

  // *For Filters
  const [filters, setFilters] = useState({});

  const [wrongVins, setWrongVins] = useState([]);

  // *For Currencies
  const [currencyExchangeRate, setCurrencyExchangeRate] = useState();

  // *For Destination filter
  const [destinations, setDestinations] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const fileInputRef = useRef(null);
  console.log(fileInputRef, "fileInputRef");
  const [excelPopupOpen, setExcelPopupOpen] = useState(false);
  const [excelsPopupOpen, setExcelsPopupOpen] = useState(false);
  const [previewExcelData, setPreviewExcelData] = useState([]);

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [vDialogOpen, setVDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [noteHeading, setNoteHeading] = useState("");
  const [costingDialogOpen, setCostingDialogOpen] = useState(false);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [savedData, setSavedData] = useState({});
  const [bookingDiscountFlags, setBookingDiscountFlags] = useState({});
  const handleOpenDialog = (item) => {
    setTableId(item);
    setDialogOpen(true);
  };
  const handleVehicleOpenDialog = (item, type) => {
    // setTableId(item);
    setVDialogOpen(true);
    // setValue("vNote", type == 'vehicle' ? item?.booking?.paymentDetails?.payment?.comments : item?.shipping?.notes)
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setVDialogOpen(false);
  };

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null); // Toggle the active menu
  };

  const tableHead = [
    "SELECT",
    "CUSTOMER",
    "PURCHASED",
    "BUYER ID",
    "MAKE/MODEL",
    "VIN",
    "LOT",
    "LOCATION",
    "DESTINATION",
    "CONTAINER",
    "ARR.PORT",
    // "LATE FEE $",
    // "STORAGE $",
    "DISC $",
    "TOTAL COSTING $",
    "CUSTOM $",
    "VAT $",
    "PAID C+V $",
    "TOTAL SHIPPING DUE $",
    "BALANCE",
    "ACTION",
  ];
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();
  const {
    register: register2,
    getValues: getValues2,
    setValue: setValue2,
    handleSubmit: handleSubmit2,
    reset,
  } = useForm();

  const classes = useStyles();

  const editableKeys = [
    "shipping_charges",
    "category_a",
    "broker_fee",
    "title_fee",
    "current_suv",
    "clearance_att_fee",
    "hybrid_fee",
    "heavy_equipment_fee",
    "parts_pickup_fee",
    "relist_reversal_fee",
    "misc_fee",
    "fuel_surcharge",
    "color_change",
    "thc_charges",
    "discount",
  ];

  const [totalSumAllRows, setTotalSumAllRows] = useState(0);

  const calculateTotal = (row) => {
    const sum = editableKeys
      .filter((key) => key !== "discount")
      .reduce((acc, key) => acc + parseFloat(row[key] || 0), 0);

    return sum.toFixed(2);
  };

  const calculateRowTotal = (row) => {
    const total =
      parseFloat(row["Shipping Charges $"] || 0) +
      parseFloat(row["Auction Late Pmt Fee $"] || 0) +
      parseFloat(row["Ship. Late Pmt Fee $"] || 0) +
      parseFloat(row["Storage $"] || 0) +
      parseFloat(row["Terminal Storages $"] || 0) +
      parseFloat(row["Cat A $"] || 0) +
      parseFloat(row["Broker Fee $"] || 0) +
      parseFloat(row["Title Fee $"] || 0) +
      parseFloat(row["SUV $"] || 0) +
      parseFloat(row["Clearance Fee $"] || 0) +
      parseFloat(row["Hybrid Fee $"] || 0) +
      parseFloat(row["Heavy Equipment Fee $"] || 0) +
      parseFloat(row["Part Pickup Fee $"] || 0) +
      parseFloat(row["Wrapping Fee $"] || 0) +
      parseFloat(row["Relist/Reversal Fee $"] || 0) +
      parseFloat(row["Misc Fee $"] || 0) +
      parseFloat(row["Fuel Surcharge $"] || 0) +
      parseFloat(row["Color Change $"] || 0) +
      parseFloat(row["THC Charges $"] || 0) +
      parseFloat(row["Intl Clearance $"] || 0) +
      parseFloat(row["Inland Transportation $"] || 0) +
      parseFloat(row["INTNL Export Charges $"] || 0) +
      parseFloat(row["Discount $"] || 0) -
      parseFloat(row["War Sur.Char Disc $"] || 0);

    return total.toFixed(2);
  };

  const handleFieldChange = (e, rowIndex, fieldName) => {
    const newValue = e.target.value;

    const updatedPreviewExcelData = [...previewExcelData];
    updatedPreviewExcelData[rowIndex][fieldName] = newValue;

    const newData = [...previewExcelData];

    const updatedTotal = calculateRowTotal(updatedPreviewExcelData[rowIndex]);

    updatedPreviewExcelData[rowIndex]["Total $"] = updatedTotal;

    setPreviewExcelData(updatedPreviewExcelData);

    const totalSum = updatedPreviewExcelData.reduce((acc, row) => {
      return acc + parseFloat(row["Total $"] || 0);
    }, 0);

    setTotalSumAllRows(totalSum.toFixed(2));
  };

  // *For Apply Filters
  const applyFilter = async (value) => {
    try {
      let data = {
        customer_id: selectedClient?.id,
        // payable: true,
        container: getValues("container"),
        search: getValues("search"),
        destination_id: selectedDestination?.id,
        // vin: getValues("vin"),
        // lot: getValues("lot"),
      };
      getClientCosting(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // *For Get Destinations (Destination filter options)
  const getDestinations = async (search) => {
    try {
      const { data } = await SystemServices.getDestinations({
        page: 1,
        limit: 200,
        search: search,
      });
      setDestinations(data?.destinations?.rows ?? []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Currencies
  const getCurrencies = async (currency) => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await CurrencyServices.getCurrencies(params);

      setCurrencyExchangeRate(data.currencies[2].conversion_rate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const discountFields = [
    "shipping_charges",
    "late_fee",
    "storage",
    "category_a",
    "broker_fee",
    "title_fee",
    "current_suv",
    "clearance_att_fee",
    "hybrid_fee",
    "heavy_equipment_fee",
    "parts_pickup_fee",
    "wrapping_fee",
    "relist_reversal_fee",
    "misc_fee",
  ];

  // Extract true fields into a new object

  const discountFlags = {};

  const getTrueDiscountFlags = (item) => {
    const matchedFlags = {};

    discountFields.forEach((field) => {
      if (item?.booking?.[field] === true) {
        matchedFlags[field] = true;
      }
    });

    return matchedFlags;
  };

  // *For Clients
  const getClientDropdown = async () => {
    try {
      const { data } = await ClientServices.getClientDropdown();

      setClients(data?.customers?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Select and DeSelect client
  // const handleSelectClientBooking = (id) => {
  //   try {
  //     const shallowCopy = [...selectedClientBooking];
  //     const currentIndex = selectedClientBooking.indexOf(id);
  //     if (currentIndex === -1) {
  //       shallowCopy.push(id);
  //     } else {
  //       shallowCopy.splice(currentIndex, 1);
  //     }
  //     setSelectedClientBooking(shallowCopy);
  //   } catch (error) {
  //     ErrorToaster(error);
  //   }
  // };
  const handleSelectClientBooking = (id, containerNo, costingsData) => {
    try {
      const shallowCopy = [...selectedClientBooking];
      let selectedVehicle = costingsData.find((item) => item.id === id);

      if (!selectedContainer) {
        // First selection, set container and select vehicle
        setSelectedContainer(containerNo);
        shallowCopy.push(id);
      } else if (selectedContainer === containerNo) {
        // Toggle selection if the container matches
        const currentIndex = shallowCopy.indexOf(id);
        if (currentIndex === -1) {
          shallowCopy.push(id);
        } else {
          shallowCopy.splice(currentIndex, 1);
        }

        // Reset if no vehicles are selected
        if (shallowCopy.length === 0) {
          setSelectedContainer(null);
        }
      } else {
        // Prevent selection of different containers
        ErrorToaster("You can only select vehicles from the same container.");
        return;
      }

      // Update selected vehicles
      const updatedVehicles = costingsData.filter((item) =>
        shallowCopy.includes(item.id),
      );
      setSelectedClientBooking(shallowCopy);
      setSelectedVehicles(updatedVehicles); // <-- Ensure selectedVehicles is updated
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Client Costing
  const getClientCosting = async (page, limit, filter) => {
    setLoader(true);
    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: Page,
        limit: Limit,
      };
      params = { ...params, ...Filter };

      const { data } = await ClientServices.getClientCostingV2(params);

      setClientCosting(data?.costings?.rows);
      setPermissions(formatPermissionData(data?.permissions));
      const newArray = data?.costings?.rows.map((item) => ({
        id: item.id,
        shipping_charges: parseFloat(item.shipping_charges), // Convert to number if needed
        broker_fee: parseFloat(item.broker_fee), // Convert to number if needed
        category_a: parseFloat(item.category_a), // Convert to number if needed
      }));

      setOldArray(newArray);

      const shallowCopy = [];
      const clientCostArray = [];

      data?.costings?.rows.forEach((e) => {
        const date = moment(e?.vehicle?.vcc?.vcc_expiry_date).format(
          "DD-MM-YYYY",
        );

        const targetDate = moment(date, "DD-MM-YYYY");
        let daysRemaining = targetDate > moment();

        let val =
          (parseFloat(e?.shipping_charges) ||
            parseFloat(e?.shipping_placeholder_charges) ||
            0) +
          (parseFloat(e?.late_fee) || 0) +
          (parseFloat(e?.storage) || 0) +
          (parseFloat(e?.terminal_storages) || 0) +
          //(parseFloat(e?.category_a) || 0) +
          // (parseFloat(e?.broker_fee) || 0) +
          (parseFloat(e?.title_fee) || 0) +
          (parseFloat(e?.other_charge) || 0) +
          (parseFloat(e?.intl_clearance) || 0) +
          (parseFloat(e?.inland_transportation) || 0) +
          (parseFloat(e?.intnl_export_charges) || 0) +
          parseFloat(e?.invoice ? e?.invoice?.custom_total : 0) +
          parseFloat(e?.invoice ? e?.invoice?.vat_total : 0) -
          (parseFloat(e?.war_surcharge_disc) || 0);

        let categoryAVal = 0;
        let brokerVal = 0;

        if (parseFloat(e?.category_a) > 0) {
          categoryAVal = parseFloat(e?.category_a);
        } else if (e?.booking?.buyer?.type == "A") {
          categoryAVal = categoryAVal;
        }

        if (parseFloat(e?.broker_fee) > 0) {
          brokerVal = parseFloat(e?.broker_fee);
        } else if (e?.booking?.buyer?.type == "B") {
          brokerVal = brokerVal;
        }

        val += categoryAVal;
        val += brokerVal;

        let copyClientCost = {
          costing_id: e?.id,
        };
        let obj = {
          id: e?.id,
          shipping_charges:
            e?.shipping_charges == 0
              ? e?.shipping_placeholder_charges
                ? e?.shipping_placeholder_charges
                : 0.0
              : e?.shipping_charges,
          late_fee: e?.late_fee,
          storage: e?.storage,
          terminal_storages: e?.terminal_storages,
          category_a: e?.category_a,
          broker_fee: e?.broker_fee,
          title_fee: e?.title_fee,
          other_charge: e?.other_charge,
          war_surcharge_disc: e?.war_surcharge_disc,
          intl_clearance: e?.intl_clearance,
          inland_transportation: e?.inland_transportation,
          intnl_export_charges: e?.intnl_export_charges,
          custom_duty: parseFloat(e?.invoice ? e?.invoice?.custom_total : 0),
          total: e?.total,
          vat: parseFloat(e?.invoice ? e?.invoice?.vat_total : 0),
          grand_total: e?.subtotal,
          paid: e?.invoice?.paid,
          vin: e?.booking?.vin,
          discount: e?.discount,
          total_shipping: e?.invoice?.shipping_total,
        };

        obj.amount = val.toFixed(2);
        obj.grand_total = val.toFixed(2);

        if (true) {
          copyClientCost.shipping_charges =
            e?.shipping_charges == 0
              ? e?.shipping_placeholder_charges
                ? e?.shipping_placeholder_charges
                : 0.0
              : e?.shipping_charges;
          copyClientCost.late_fee = e?.late_fee;
          copyClientCost.storage = e?.storage;
          copyClientCost.terminal_storages = e?.terminal_storages;
          copyClientCost.category_a = e?.category_a;
          copyClientCost.broker_fee = e?.broker_fee;
          copyClientCost.title_fee = e?.title_fee;
          copyClientCost.other_charge = e?.other_charge;
          copyClientCost.war_surcharge_disc = e?.war_surcharge_disc;
          copyClientCost.intl_clearance = e?.intl_clearance;
          copyClientCost.inland_transportation = e?.inland_transportation;
          copyClientCost.intnl_export_charges = e?.intnl_export_charges;
          copyClientCost.custom_duty = parseFloat(
            e?.vehicle?.vcc?.custom_due
              ? e?.custom_duty == 0
                ? e?.vehicle?.vcc?.custom_charges_aed / currencyExchangeRate
                : e?.custom_duty
              : 0,
          );
          copyClientCost.discount = e?.discount;
          copyClientCost.vat = parseFloat(
            e?.vehicle?.vcc?.vat_due
              ? e?.vat == 0
                ? e?.vehicle?.vcc?.vat_charges_aed / currencyExchangeRate
                : e?.vat
              : 0,
          );
        }

        shallowCopy.push(obj);
        clientCostArray.push(copyClientCost);
      });
      reset();
      setTotalAmount(shallowCopy);

      setCopyClientCosting(clientCostArray);

      setTotalCount(data?.costings?.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };
  const [valuesObject, seValuesObject] = useState([]);
  let arrayOfObjects = [...valuesObject];
  // Function to add or update values in the array
  function addOrUpdateValue(id, value, value2, value3) {
    // Check if the id already exists in the array
    const index = arrayOfObjects.findIndex((obj) => obj.id === id);

    // If the id exists, update the value
    if (index !== -1) {
      arrayOfObjects[index].value = parseFloat(value)?.toFixed(2);
      arrayOfObjects[index].value2 = parseFloat(value2)?.toFixed(2);
      arrayOfObjects[index].value3 = parseFloat(value3)?.toFixed(2);
    } else {
      // If the id doesn't exist, add a new object
      arrayOfObjects.push({ id, value, value2, value3 });
    }
  }

  const getClientCostings = async (
    page,
    limit,
    filter,
    opts = { fetchAll: false },
  ) => {
    const Page = page ?? 1;
    const Limit = limit ? limit : pageLimits;
    const Filter = { ...filters, ...filter };

    if (!opts.fetchAll) {
      setLoader(true);
      try {
        let params = { page: Page, limit: Limit, ...Filter };
        const { data } = await ClientServices.getClientCostingV2(params);
        setClientCostingData(data?.costings?.rows || []);
      } catch (error) {
        ErrorToaster(error);
      } finally {
        setLoader(false);
      }
      return;
    }

    if (isPrefetching) return;

    setIsPrefetching(true);
    setIsPrefetchComplete(false);
    prefetchAbortRef.current.aborted = false;
    setPrefetchProgress({ done: 0, total: 0 });

    try {
      let params = { page: 1, limit: pageLimits, ...Filter };
      const first = await ClientServices.getClientCostingV2(params);
      const totalCount = Number(first?.data?.costings?.count || 0);
      const firstRows = first?.data?.costings?.rows || [];
      const totalPages = Math.max(1, Math.ceil(totalCount / pageLimits));

      setClientCostingData(firstRows);
      setPrefetchProgress({ done: firstRows.length, total: totalCount });

      for (let p = 2; p <= totalPages; p++) {
        if (prefetchAbortRef.current.aborted) break;

        const res = await ClientServices.getClientCostingV2({
          page: p,
          limit: pageLimits,
          ...Filter,
        });
        const rows = res?.data?.costings?.rows || [];

        setClientCostingData((prev) => prev.concat(rows));

        setPrefetchProgress((prev) => ({
          done: Math.min(totalCount, prev.done + rows.length),
          total: totalCount,
        }));
      }

      if (!prefetchAbortRef.current.aborted) {
        setIsPrefetchComplete(true);
      }
    } catch (err) {
      ErrorToaster(err);
    } finally {
      setIsPrefetching(false);
    }
  };

  const handleDownloadExcelFormat = () => {
    const shippingHeaders = [
      "Customer Name",
      "Customer Code",
      "VIN",
      "LOT",
      "Shipping Charges $",
      "Auction Late Pmt Fee $",
      "Ship. Late Pmt Fee $",
      "Storage $",
      "Terminal Storages $",
      "Cat A $",
      "Broker Fee $",
      "Title Fee $",
      "SUV $",
      "Clearance Fee $",
      "Hybrid Fee $",
      "Heavy Equipment Fee $",
      "Part Pickup Fee $",
      "Wrapping Fee $",
      "Relist/Reversal Fee $",
      "Misc Fee $",
      "Fuel Surcharge $",
      "Color Change $",
      "THC Charges $",
      "Intl Clearance $",
      "Inland Transportation $",
      "INTNL Export Charges $",
      "Discount $",
      "War Sur.Char Disc $",
      "Total $",
      "S Comment",
    ];

    const shippingData = [];

    const generateExcelFile = async (headers, data, fileName) => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");
      worksheet.addRow(headers);
      data.forEach((row) => worksheet.addRow(row));

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), fileName);
    };

    generateExcelFile(
      shippingHeaders,
      shippingData,
      "client_costing_format.xlsx",
    );
  };

  // const getClientCostings = async (page, limit, filter, opts = { fetchAll: false }) => {
  //     setLoader(true);
  //     try {
  //         const Page = page ? page : currentPage;
  //         const Limit = limit ? limit : pageLimits;
  //         const Filter = { ...filters, ...filter };
  //         setCurrentPage(Page);
  //         setPageLimits(Limit);
  //         setFilters(Filter);
  //         let params = {
  //             page: Page,
  //             limit: Limit,
  //         };
  //         params = { ...params, ...Filter };

  //         const { data } = await ClientServices.getClientCostingV2(params);

  //         setClientCostingData(data?.costings?.rows);

  //     } catch (error) {
  //         ErrorToaster(error);
  //     } finally {
  //         setLoader(false);
  //     }
  // };

  // Print the array of objects
  const handleCalc = (fieldName, id, currency, val, item) => {
    if (!val.match(/^\d{1,}(\.\d{0,2})?$/)) {
      return;
    }

    const updatedValue = parseFloat(val).toFixed(2);
    setValue(`${id}-${fieldName}`, updatedValue);

    setSavedData((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [fieldName]: updatedValue,
      },
    }));

    try {
      const shallowCopy = [...totalAmount];
      const index = shallowCopy.findIndex((e) => e.id === id);
      if (index === -1) return;

      let usd;
      if (currency === "cad") {
        const aed = updatedValue * cadExchangeRate;
        usd = aed / usdExchangeRate;
      } else if (currency === "aed") {
        usd = updatedValue / usdExchangeRate;
      } else {
        usd = updatedValue;
      }

      shallowCopy[index][fieldName] = parseFloat(usd);

      const fieldsToCalculate = [
        "shipping_charges",
        "late_fee",
        "storage",
        "terminal_storages",
        "category_a",
        "broker_fee",
        "title_fee",
        "current_suv",
        "clearance_att_fee",
        "hybrid_fee",
        "heavy_equipment_fee",
        "parts_pickup_fee",
        "wrapping_fee",
        "relist_reversal_fee",
        "misc_fee",
        "fuel_surcharge",
        "color_change",
        "thc_charges",
        "intl_clearance",
        "inland_transportation",
        "intnl_export_charges",
        "discount",
        "war_surcharge_disc",
      ];

      const total = fieldsToCalculate.reduce(
        (sum, key) =>
          key === "war_surcharge_disc"
            ? sum - parseFloat(shallowCopy[index][key] || 0)
            : sum + parseFloat(shallowCopy[index][key] || 0),
        0,
      );

      const vat = parseFloat(shallowCopy[index]["vat"] || 0);
      const grandTotal = total + vat;
      shallowCopy[index].amount = total.toFixed(2);
      shallowCopy[index].grand_total = grandTotal.toFixed(2);
      shallowCopy[index].total_costing = total.toFixed(2);

      setTotalAmount(shallowCopy);

      setSavedData((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          total_costing: total.toFixed(2),
        },
      }));

      setValue(`${id}-total_costing`, total.toFixed(2));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const [visibleColumns, setVisibleColumns] = useState([
    ...Array(tableHead.length).keys(),
  ]);

  const handleDelete = async () => {
    try {
      const { costing_id, booking_id } = deleteDetails;

      const obj = { costing_id, booking_id };
      const response = await ClientServices.removeClientCosting(obj);

      if (response?.message) {
        SuccessToaster(response.message);
      } else {
        SuccessToaster("Client Costing Deleted successfully");
      }

      setOpenDeleteModal(false);
      getClientCosting();
      window.location.reload();
    } catch (error) {
      const errorMessage = error || "Failed to delete Client Costing";
      ErrorToaster(errorMessage);
    }
  };

  const openDeleteDialog = (costing_id, booking_id) => {
    setDeleteDetails({ costing_id, booking_id });
    setOpenDeleteModal(true);
  };

  const handleColumnChange = (event) => {
    const selectedColumns = event.target.value;
    // Sort the selected columns to maintain the correct order
    const sortedColumns = selectedColumns.sort((a, b) => a - b);
    setVisibleColumns(sortedColumns);
  };

  // *For Update Vendor Costing
  const updateClientCosting = async (formData) => {
    setLoading(true);
    try {
      const costings = [];
      let costingId = Object.keys(formData)[0].split("-")[0];

      let costObj = {};

      for (let key in formData) {
        const costingDetail = clientCosting.find((e) => e.id == costingId);
        if (costingId === key.split("-")[0]) {
          const date = moment(
            costingDetail?.vehicle?.vcc?.vcc_expiry_date,
          ).format("DD-MM-YYYY");

          const targetDate = moment(date, "DD-MM-YYYY");
          let daysRemaining = targetDate > moment();
          const objKey = key.split("-")[1];
          costObj["costing_id"] = costingId;
          costObj["booking_id"] = costingDetail?.booking_id;
          costObj["customer_id"] = costingDetail?.booking?.customer_id;
          costObj["customer_phone"] =
            costingDetail?.booking?.customer?.uae_phone;
          costObj["custom_duty"] = parseFloat(
            costingDetail?.vehicle?.vcc?.custom_due
              ? costingDetail?.custom_duty == 0
                ? costingDetail?.vehicle?.vcc?.custom_charges_aed /
                currencyExchangeRate
                : costingDetail?.custom_duty
              : 0,
          );
          costObj["vat"] = parseFloat(
            costingDetail?.vehicle?.vcc?.vat_due
              ? costingDetail?.vat == 0
                ? costingDetail?.vehicle?.vcc?.vat_charges_aed /
                currencyExchangeRate
                : costingDetail?.vat
              : 0,
          );
          costObj["vendor_type"] = selectedClient?.type;
          costObj["vendor_account_id"] = selectedClient?.account_id;
          costObj["container_no"] = costingDetail?.shipping?.container_no;
          costObj["vehicle_make"] = costingDetail?.booking?.veh_make?.name;
          costObj["vehicle_model"] = costingDetail?.booking?.veh_model?.name;
          costObj["vin"] = costingDetail?.booking?.vin;
          costObj["lot_number"] = costingDetail?.booking?.lot_number;
          costObj["color"] = costingDetail?.booking?.color;
          costObj["loading_port"] = costingDetail?.shipping?.loading_port?.name;
          costObj["location"] = costingDetail?.shipping?.location
            ? `${costingDetail?.shipping?.location?.state_code}-${costingDetail?.shipping?.location?.city_name}`
            : null;
          costObj["country_code"] = costingDetail?.shipping?.location
            ? costingDetail?.shipping?.location?.country_code
            : null;
          costObj["destination"] = costingDetail?.shipping?.dest?.name;
          costObj["galaxy_arrival_date"] =
            costingDetail?.vehicle?.arrived_galaxy_date;
          costObj["port_date"] =
            costingDetail?.vehicle?.arrived_port_date || null;

          costObj[objKey] = formData[key] === "" ? 0 : formData[key];
        } else {
          const date = moment(
            costingDetail?.vehicle?.vcc?.vcc_expiry_date,
          ).format("DD-MM-YYYY");
          const targetDate = moment(date, "DD-MM-YYYY");
          let daysRemaining = targetDate.diff(moment(), "days");
          if (daysRemaining < 0) {
            daysRemaining = 0;
          }
          costings.push(costObj);
          costingId = key.split("-")[0];
          costObj = {};
          const objKey = key.split("-")[1];
          costObj["costing_id"] = costingId;
          costObj["vendor_type"] = selectedClient?.type;
          costObj["booking_id"] = costingDetail?.booking_id;
          costObj["customer_id"] = costingDetail?.booking?.customer_id;
          costObj["customer_phone"] =
            costingDetail?.booking?.customer?.uae_phone;
          costObj["custom_duty"] = parseFloat(
            costingDetail?.vehicle?.vcc?.custom_due
              ? costingDetail?.custom_duty == 0
                ? costingDetail?.vehicle?.vcc?.custom_charges_aed /
                currencyExchangeRate
                : costingDetail?.custom_duty
              : 0,
          );
          costObj["vat"] = parseFloat(
            costingDetail?.vehicle?.vcc?.vat_due
              ? costingDetail?.vat == 0
                ? costingDetail?.vehicle?.vcc?.vat_charges_aed /
                currencyExchangeRate
                : costingDetail?.vat
              : 0,
          );
          costObj["vendor_account_id"] = selectedClient?.account_id;
          costObj["container_no"] = costingDetail?.shipping?.container_no;
          costObj["vehicle_make"] = costingDetail?.booking?.veh_make?.name;
          costObj["vehicle_model"] = costingDetail?.booking?.veh_model?.name;
          costObj["vin"] = costingDetail?.booking?.vin;
          costObj["lot_number"] = costingDetail?.booking?.lot_number;
          costObj["color"] = costingDetail?.booking?.color;
          costObj["loading_port"] = costingDetail?.shipping?.loading_port?.name;
          costObj["location"] = costingDetail?.shipping?.location
            ? `${costingDetail?.shipping?.location?.state_code}-${costingDetail?.shipping?.location?.city_name}`
            : null;
          costObj["country_code"] = costingDetail?.shipping?.location
            ? costingDetail?.shipping?.location?.country_code
            : null;
          costObj["destination"] = costingDetail?.shipping?.dest?.name;
          costObj["galaxy_arrival_date"] =
            costingDetail?.vehicle?.arrived_galaxy_date;
          costObj[objKey] = formData[key] === "" ? 0 : formData[key];
          costObj["port_date"] =
            costingDetail?.vehicle?.arrived_port_date || null;
        }
      }
      costings.push(costObj);
      const costShallowCopy = [...costings];

      // let newArray = costShallowCopy.map(
      //     ({
      //         vendor_type,
      //         vendor_account_id,
      //         container_no,
      //         vehicle_make,
      //         vehicle_model,
      //         vin,
      //         lot_number,
      //         color,
      //         location,
      //         country_code,
      //         destination,
      //         port_date,
      //         galaxy_arrival_date,
      //         booking_id,
      //         custom_duty,
      //         vat,

      //         customer_id,
      //         customer_phone,
      //         ...rest
      //     }) => rest
      // );

      let newArray = costShallowCopy.map((item) => {
        const {
          vendor_type,
          vendor_account_id,
          container_no,
          vehicle_make,
          vehicle_model,
          vin,
          lot_number,
          color,
          location,
          country_code,
          destination,
          port_date,
          galaxy_arrival_date,
          booking_id,
          custom_duty,
          vat,
          customer_id,
          customer_phone,
          ...rest
        } = item;

        return {
          ...rest,
          port_date: port_date || null, // <-- explicitly add port_date here
        };
      });

      const difference = findDifferences(newArray, copyClientCosting);

      const newArr = [];

      difference.forEach((e) => {
        if (selectedClientBooking.indexOf(parseInt(e?.costing_id)) !== -1) {
          const findData = costings.find(
            (j) => j?.costing_id === e?.costing_id,
          );
          let obj = {
            ...e,

            booking_id: findData?.booking_id,
            customer_id: findData?.customer_id,
            customer_phone: findData?.customer_phone,
            container_no: findData?.container_no,
            vehicle_make: findData?.vehicle_make,
            vehicle_model: findData?.vehicle_model,
            vin: findData?.vin,
            lot_number: findData?.lot_number,
            color: findData?.color,
            loading_port: findData?.loading_port,
            location: findData?.location,
            country_code: findData?.country_code,
            destination: findData?.destination,
            galaxy_arrival_date: findData?.galaxy_arrival_date,
            port_date: findData?.port_date,
            custom_duty: findData.custom_duty || e.custom_duty, // Use default value from e if not present in findData
            vat: findData.vat || e.vat, // Use default value from e if not present in findData
          };

          newArr.push(obj);
        }
      });

      const idToValueMap = {};
      const idToValue2Map = {};
      const idToValue3Map = {};
      valuesObject.forEach((item) => {
        idToValueMap[item.id] = item.value;
        idToValue2Map[item.id] = item.value2;
        idToValue3Map[item.id] = item.value3;
      });

      const updatedArray = newArr.map((item) => {
        const matchingValue = idToValueMap[item.costing_id];
        const matchingValue2 = idToValue2Map[item.costing_id];
        const matchingValue3 = idToValue3Map[item.costing_id];

        if (matchingValue !== undefined) {
          if (item.category_a !== undefined) {
            item = { ...item, category_a: matchingValue };
          } else {
            item = { ...item, category_a: matchingValue };
          }
        }

        if (matchingValue2 !== undefined) {
          if (item.value2 !== undefined) {
            item = { ...item, broker_fee: matchingValue2 };
          } else {
            item = { ...item, broker_fee: matchingValue2 };
          }
        }
        if (matchingValue3 !== undefined) {
          if (item.value3 !== undefined) {
            item = { ...item, shipping_charges: matchingValue3 };
          } else {
            item = { ...item, shipping_charges: matchingValue3 };
          }
        }

        return item;
      });

      // Update newArray by removing specified keys only if old and new values are the same
      const updatedArray2 = updatedArray.map((obj2) => {
        const obj1 = oldArray.find(
          (item) => item.id.toString() === obj2.costing_id,
        );
        if (obj1 && obj1.broker_fee == obj2.broker_fee) {
          delete obj2.broker_fee;
        }
        if (obj1 && obj1.shipping_charges == obj2.shipping_charges) {
          delete obj2.shipping_charges;
        }
        if (obj1 && obj1.category_a == obj2.category_a) {
          delete obj2.category_a;
        }
        return obj2;
      });

      const updatedArrayWithDiscountAed = updatedArray2.map((item) => ({
        ...item,
        discount_aed: (
          (parseFloat(item?.discount || 0) || 0) *
          (parseFloat(usdExchangeRate || 0) || 0)
        ).toFixed(2),
      }));

      let obj = {
        costings: updatedArrayWithDiscountAed,
      };

      const { message } = await ClientServices.updateClientCostingV2(obj);
      SuccessToaster(message);
      setSelectedClientBooking([]);
      navigate("/shipping-costing-v2");
      let data = {
        container_id: selectedClient?.id,
      };
      getClientCosting(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const convertToNumber = (input, decimal = 2) =>
    isNaN(Number(input)) ? 0 : Number(Number(input).toFixed(decimal));

  const renderCellContent = (colIndex, item, isActive) => {
    const date = moment(item?.vehicle?.vcc?.vcc_expiry_date).format(
      "DD-MM-YYYY",
    );
    const targetDate = moment(date, "DD-MM-YYYY");
    let daysRemaining = targetDate > moment();
    const totalCustomPaid = item?.invoice?.payment?.reduce(
      (total, { custom_amount }) => total + convertToNumber(custom_amount || 0),
      0,
    );
    const totalVatPaid = item?.invoice?.payment?.reduce(
      (total, { vat_amount }) => total + convertToNumber(vat_amount || 0),
      0,
    );
    const remainingCustom = convertToNumber(
      item?.invoice?.custom_total || 0 - totalCustomPaid || 0,
      2,
    );
    const remainingVat = convertToNumber(
      item?.invoice?.vat_total || 0 - totalVatPaid || 0,
      2,
    );
    const totalCustomPaidUSD = parseFloat(
      totalCustomPaid / currencyExchangeRate,
    ).toFixed(2);
    const totalVatPaidUSD = parseFloat(
      totalVatPaid / currencyExchangeRate,
    ).toFixed(2);
    const sumCustomVat = parseFloat(totalCustomPaid) + parseFloat(totalVatPaid);
    const val = parseFloat(totalAmount.find((e) => e?.id === item?.id)?.total);
    const shippingTotal = parseFloat(item?.invoice?.shipping_total || 0);
    const totalCustomSHip = parseFloat(item?.invoice?.custom_total) || 0;
    const totalVatShip = parseFloat(item?.invoice?.vat_total) || 0;
    const total = parseFloat(item?.total_v2) || 0;
    const displayedDiscount =
      parseFloat(
        item?.discount !== "0.000"
          ? item?.discount
          : (item?.booking?.user_disc ?? 0),
      ) || 0;

    // Sum of total, custom, and vat
    const totalShippingDue = total + totalCustomSHip + totalVatShip;

    switch (colIndex) {
      case 0:
        return (
          <Checkbox
            checked={selectedClientBooking.includes(item.id)}
            onChange={() =>
              handleSelectClientBooking(
                item.id,
                item?.shipping?.container_no,
                clientCosting,
              )
            }
            disabled={
              selectedContainer &&
              selectedContainer !== item?.shipping?.container_no
            }
          />
        );

      case 1:
        const customerName = item?.booking?.customer?.name ?? "-";
        const shouldWrap = customerName.length > 19;

        return (
          <Box
            sx={{
              whiteSpace: shouldWrap ? "normal" : "nowrap",
              wordBreak: shouldWrap ? "break-word" : "unset",
              maxWidth: "200px",
              mx: "auto",
            }}
          >
            {customerName}
          </Box>
        );

      case 2:
        return item?.booking?.purchase_date
          ? moment(item?.booking?.purchase_date).format("DD-MMM-YYYY")
          : "-";
      case 3:
        return item?.booking?.buyer?.name ?? "-";
      case 4:
        const make = item?.booking?.veh_make?.name ?? "";
        const model = item?.booking?.veh_model?.name ?? "";
        return make && model ? `${make} - ${model}` : make || model || "-";
      case 5:
        const customerVin = item?.booking?.vin ?? "-";
        const shouldWrapp = customerVin.length > 19;

        return (
          <Box
            sx={{
              whiteSpace: shouldWrapp ? "normal" : "nowrap",
              wordBreak: shouldWrapp ? "break-word" : "unset",
              maxWidth: "200px",
              mx: "auto",
            }}
          >
            {customerVin}
          </Box>
        );
      case 6:
        return item?.booking?.lot_number ?? "-";
      case 7:
        return item?.shipping?.loading_port?.name ?? "-";
      case 8:
        return item?.shipping?.dest?.name ?? "-";
      case 9:
        return item?.shipping?.container_no ?? "-";
      case 10:
        return item?.vehicle?.arrived_port_date
          ? moment(item?.vehicle?.arrived_port_date).format("DD-MMM-YYYY")
          : "-";
      // case 10:
      //     return CommaSeparator(parseFloat(item?.late_fee).toFixed(2)) ?? "-";
      // case 11:
      //     return CommaSeparator(parseFloat(item?.storage).toFixed(2)) ?? "-";
      case 11:
        return CommaSeparator(displayedDiscount.toFixed(2)) ?? "-";
      // return CommaSeparator(
      //     parseFloat(
      //         totalAmount.find((e) => e?.id === item?.id)?.total
      //     ).toFixed(2)
      // ) ?? "-";
      case 12:
        return CommaSeparator((total + displayedDiscount).toFixed(2)) ?? "-";
      case 13:
        return CommaSeparator(
          parseFloat(item?.invoice?.custom_total).toFixed(2) ==
            parseFloat(totalCustomPaid).toFixed(2)
            ? 0
            : parseFloat(remainingCustom - totalCustomPaid).toFixed(2),
        );

      case 14:
        return CommaSeparator(
          parseFloat(item?.invoice?.vat_total).toFixed(2) ==
            parseFloat(totalVatPaid).toFixed(2)
            ? 0
            : parseFloat(remainingVat - totalVatPaid).toFixed(2),
        );
      case 15:
        return (
          <Box sx={{ color: Colors.green }}>
            {CommaSeparator(
              parseFloat(item?.invoice?.custom_vat_paid).toFixed(2),
            ) ?? "-"}
          </Box>
        );
      case 16:
        return showDue
          ? CommaSeparator(parseFloat(totalShippingDue).toFixed(2))
          : CommaSeparator(parseFloat(totalShippingDue).toFixed(2));
      case 17:
        return (
          CommaSeparator(
            parseFloat(
              item?.invoice?.balance -
              (item?.discount == "0.000" && item?.booking?.user_disc
                ? item?.booking?.user_disc
                : 0),
            ).toFixed(2),
          ) ?? "-"
        );
      // return showDue
      //   ? CommaSeparator(
      //     parseFloat(
      //       totalAmount.find((e) => e?.id === item?.id)?.grand_total
      //     ) -
      //     parseFloat(
      //       totalAmount.find((e) => e?.id === item?.id)?.discount
      //     )
      //   )
      //   : CommaSeparator(
      //     parseFloat(
      //       totalAmount.find((e) => e?.id === item?.id)?.grand_total
      //     ) -
      //     parseFloat(
      //       totalAmount.find((e) => e?.id === item?.id)?.discount
      //     )
      //   );
      //     case 19:
      //         return (
      //             <Box sx={{ display: "flex", gap: 1 }}>
      //                 <Box
      //                     component={"div"}
      //                     onClick={() => {
      //                         handleVehicleOpenDialog(item);
      //                         setNoteHeading("Vehicle Note");
      //                         setValue(
      //                             "vNote",
      //                             item?.booking?.paymentDetails?.payment?.comments
      //                         );
      //                     }}
      //                 >
      //                     V
      //                 </Box>
      //                 |
      //                 <Box
      //                     component={"div"}
      //                     onClick={() => {
      //                         handleOpenDialog(item);
      //                     }}
      //                 >
      //                     S
      //                 </Box>
      //                 |
      //                 <Box
      //                     component={"div"}
      //                     onClick={() => {
      //                         handleVehicleOpenDialog(item);
      //                         setNoteHeading("Container Note");

      //                         setValue("vNote", item?.shipping?.notes);
      //                     }}
      //                 >
      //                     C
      //                 </Box>
      //                 {/* <EditNote
      //     sx={{
      //       color: "#E3E3E3",
      //       cursor: "pointer",
      //     }}
      //     onClick={() => {
      //       handleOpenDialog(item);
      //     }}
      //   /> */}
      //             </Box>
      //         );
      case 18:
        return (
          <DropdownMenu
            item={item}
            // permissions={permissions}
            navigate={navigate}
            isOpen={activeMenu === item.id}
            onToggle={(isOpen) => handleMenuToggle(item?.id, isOpen)}
            id={item?.id}
            viewClientCosting={() => {
              const total = parseFloat(item?.total_v2);
              if (!isNaN(total) && total !== 0) {
                navigate(`/client-invoice-detail-v2/${item?.invoice?.id}`, {
                  state: {
                    shipping: true,
                  },
                });
              }
            }}
            deleteClientCosting={() => {
              if (
                (item?.vehicle?.vcc?.custom_charges_aed == null ||
                  parseFloat(item?.vehicle?.vcc?.custom_charges_aed) === 0) &&
                (item?.vehicle?.vcc?.vat_charges_aed == null ||
                  parseFloat(item?.vehicle?.vcc?.vat_charges_aed) === 0) &&
                parseFloat(item?.invoice?.paid) === 0
              ) {
                openDeleteDialog(item?.id, item?.booking?.id);
              }
            }}
            clientCostingNotes={() => {
              handleVehicleOpenDialog(item);
              setNoteHeading("Vehicle Note");
              setValue(
                "vNote",
                item?.booking?.paymentDetails?.payment?.comments,
              );
            }}
            clientCostingNotesS={() => {
              handleOpenDialog(item);
            }}
            clientCostingNotesC={() => {
              handleVehicleOpenDialog(item);
              setNoteHeading("Container Note");

              setValue("vNote", item?.shipping?.notes);
            }}
          />
        );

      default:
        return "-";
    }
  };

  const generateBatchNumber = () => {
    const newBatchNumber = `CC-${String(batchCounter).padStart(3, "0")}`;
    setBatchNumber(newBatchNumber);
    setBatchCounter(batchCounter + 1);
    return newBatchNumber;
  };

  const headerDisplayName = (key) =>
    key === "batch_number" ? "Batch Number" : key;

  // const parseAndOpenExcel = (file) => {
  //     console.log(file, 'file')
  //   const reader = new FileReader();

  //   reader.onload = (evt) => {
  //     setExcelPopupOpen(true);
  //   };

  //   if (file.type === "text/csv") {
  //     reader.readAsText(file);
  //   } else {
  //     reader.readAsBinaryString(file);
  //   }
  // };

  const [pendingFile, setPendingFile] = useState(null);

  // const matchVinsInBackground = (excelData) => {
  //     setIsPrefetching(true);
  //     setIsPrefetchComplete(false);

  //     // Start matching VINs in the background
  //     const totalVins = excelData.length;
  //     let matchedVins = 0;

  //     // Simulate the VIN matching process (this could be an API call or some other async process)
  //     const intervalId = setInterval(() => {
  //         matchedVins += 10; // Simulate 10 VINs matched per interval (you should adjust this as per your actual logic)

  //         // Update progress
  //         setPrefetchProgress({
  //             done: matchedVins,
  //             total: totalVins,
  //         });

  //         if (matchedVins >= totalVins) {
  //             // Stop the interval when matching is complete
  //             clearInterval(intervalId);
  //             setIsPrefetchComplete(true); // Mark the matching as complete
  //         }
  //     }, 100); // Simulate a delay between each VIN match (100ms in this case)
  // };

  const parseAndOpenExcel = (file) => {
    console.log(file, "file in parse and open excel");
    const reader = new FileReader();

    const getCellValue = (value) => {
      if (value === null || value === undefined) return "";

      if (typeof value === "object") {
        if (value.richText) {
          return value.richText.map((item) => item.text).join("");
        }

        if (value.text) {
          return value.text;
        }

        if (value.hyperlink) {
          return value.text || value.hyperlink;
        }

        if (value.formula) {
          return value.result ?? "";
        }

        if (value.result !== undefined) {
          return value.result;
        }

        if (value instanceof Date) {
          return value;
        }
      }

      return value;
    };

    reader.onload = async (evt) => {
      let jsonData = [];
      let headers = [];

      try {
        const fileData = evt.target?.result;
        const workbook = new ExcelJS.Workbook();

        const isCsv =
          file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

        if (isCsv) {
          const csvText = evt.target?.result;

          await workbook.csv.read(Buffer.from(csvText));

          const worksheet = workbook.worksheets[0];

          worksheet
            .getRow(1)
            .eachCell({ includeEmpty: true }, (cell, colNumber) => {
              headers[colNumber - 1] = String(getCellValue(cell.value)).trim();
            });

          worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
            if (rowNumber === 1) return;

            const rowData = {};
            for (let colNumber = 1; colNumber <= headers.length; colNumber++) {
              const header = headers[colNumber - 1];
              if (!header) continue;

              const cell = row.getCell(colNumber);
              rowData[header] = getCellValue(cell.value);
            }

            jsonData.push(rowData);
          });
        } else {
          await workbook.xlsx.load(fileData);
          const worksheet = workbook.worksheets[0];

          worksheet
            .getRow(1)
            .eachCell({ includeEmpty: true }, (cell, colNumber) => {
              headers[colNumber - 1] = String(getCellValue(cell.value)).trim();
            });

          worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
            if (rowNumber === 1) return;

            const rowData = {};
            for (let colNumber = 1; colNumber <= headers.length; colNumber++) {
              const header = headers[colNumber - 1];
              if (!header) continue;

              const cell = row.getCell(colNumber);
              rowData[header] = getCellValue(cell.value);
            }

            jsonData.push(rowData);
          });

          console.log("XLSX Headers:", headers);
          console.log("XLSX First Row:", jsonData[0]);
          console.log("XLSX Parsed JSON:", jsonData);
        }

        if (!jsonData.length) {
          ErrorToaster("No data found in file.");
          return;
        }

        const requiredHeaders = [
          "VIN",
          "LOT",
          "Shipping Charges $",
          "Auction Late Pmt Fee $",
          "Ship. Late Pmt Fee $",
          "Storage $",
          "Terminal Storages $",
          "Cat A $",
          "Broker Fee $",
          "Title Fee $",
          "SUV $",
          "Clearance Fee $",
          "Hybrid Fee $",
          "Heavy Equipment Fee $",
          "Part Pickup Fee $",
          "Wrapping Fee $",
          "Relist/Reversal Fee $",
          "Misc Fee $",
          "Fuel Surcharge $",
          "Color Change $",
          "THC Charges $",
          "Intl Clearance $",
          "Inland Transportation $",
          "INTNL Export Charges $",
          "Discount $",
          "War Sur.Char Disc $",
          "Total $",
          "S Comment",
        ];

        const missingRequired = requiredHeaders.filter(
          (h) => !headers.includes(h),
        );

        if (missingRequired.length) {
          ErrorToaster(
            `Uploaded Excel is missing required column(s): ${missingRequired.join(", ")}`,
          );
          return;
        }

        const headerMap = {
          "Shipping Charges $": "shipping_charges",
          "Auction Late Pmt Fee $": "late_fee",
          "Ship. Late Pmt Fee $": "ship_late_fee",
          "Storage $": "storage",
          "Terminal Storages $": "terminal_storages",
          "Cat A $": "category_a",
          "Broker Fee $": "broker_fee",
          "Title Fee $": "title_fee",
          "SUV $": "current_suv",
          "Clearance Fee $": "clearance_att_fee",
          "Hybrid Fee $": "hybrid_fee",
          "Heavy Equipment Fee $": "heavy_equipment_fee",
          "Part Pickup Fee $": "parts_pickup_fee",
          "Wrapping Fee $": "wrapping_fee",
          "Relist/Reversal Fee $": "relist_reversal_fee",
          "Misc Fee $": "misc_fee",
          "Fuel Surcharge $": "fuel_surcharge",
          "Color Change $": "color_change",
          "THC Charges $": "thc_charges",
          "Intl Clearance $": "intl_clearance",
          "Inland Transportation $": "inland_transportation",
          "INTNL Export Charges $": "intnl_export_charges",
          "Discount $": "discount",
          "War Sur.Char Disc $": "war_surcharge_disc",
          "Total $": "total_costing",
          "S Comment": "notes",
          "Customer Name": "customer_name",
          "Customer Code": "customer_code",
        };

        setUploadHeaderMap(headerMap);
        setUploadTextHeaders(["S Comment"]);
        generateBatchNumber();

        const withSerialNumber = jsonData.map((row, index) => ({
          serialNumber: index + 1,
          ...row,
        }));

        setPreviewExcelData(withSerialNumber);
        setExcelsPopupOpen(false);
        setExcelPopupOpen(true);
      } catch (err) {
        console.error("Excel read error:", err);
        ErrorToaster("Failed to read Excel file.");
      } finally {
        setIsUploading(false);
      }
    };

    const isCsv =
      file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

    if (isCsv) {
      reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };

  const handleFileUploadPreview = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!isPrefetchComplete) {
      setPendingFile(file);
      setIsUploading(true);
      setExcelsPopupOpen(true);
      if (!isPrefetching) {
        getClientCostings(1, pageLimits, {}, { fetchAll: true });
      }
      e.target.value = "";
      return;
    }

    setIsUploading(true);
    setExcelsPopupOpen(true);
    parseAndOpenExcel(file);
    e.target.value = "";
  };

  useEffect(() => {
    if (isPrefetchComplete && pendingFile) {
      parseAndOpenExcel(pendingFile);
      setPendingFile(null);
    }
  }, [isPrefetchComplete, pendingFile]);

  useEffect(() => {
    if (!isPrefetching && !isPrefetchComplete && pendingFile) {
      setPendingFile(null);
      setIsUploading(false);
      setExcelsPopupOpen(false);
    }
  }, [isPrefetching, isPrefetchComplete, pendingFile]);
  // const handleFileUploadPreview = (e) => {
  //     const file = e.target.files[0];
  //     if (!file) return;

  //     const reader = new FileReader();

  //     reader.onload = (evt) => {
  //         const fileData = evt.target.result;
  //         let jsonData = [];

  //         try {
  //             if (file.type === "text/csv") {
  //                 const workbook = XLSX.read(fileData, { type: "string" });
  //                 const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //                 jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
  //             } else {
  //                 const workbook = XLSX.read(fileData, { type: "binary" });
  //                 const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //                 jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
  //             }

  //             if (!jsonData || jsonData.length === 0) {
  //                 ErrorToaster("No data found in file.");
  //                 return;
  //             }

  //             const firstRowKeys = Object.keys(jsonData[0] || {});

  //             const requiredHeaders = [
  //                 'VIN',
  //                 'LOT',
  //                 'Shipping Charges $',
  //                 'Cat A $',
  //                 'Broker Fee $',
  //                 'Title Fee $',
  //                 'SUV $',
  //                 'Clearance Fee $',
  //                 'Hybrid Fee $',
  //                 'Heavy Equipment Fee $',
  //                 'Part Pickup Fee $',
  //                 'Relist/Reversal Fee $',
  //                 'Misc Fee $',
  //                 'Discount $',
  //                 'Total $',
  //                 'S Comment',
  //             ];

  //             const optionalHeaders = [
  //                 'Customer Name',
  //                 'Customer Code',
  //             ];

  //             const missingRequired = requiredHeaders.filter(
  //                 (h) => !firstRowKeys.includes(h)
  //             );

  //             if (missingRequired.length) {
  //                 ErrorToaster(
  //                     `Uploaded Excel is missing required column(s): ${missingRequired.join(', ')}`
  //                 );
  //                 return;
  //             }

  //             const headerMap = {
  //                 'Shipping Charges $': 'shipping_charges',
  //                 'Cat A $': 'category_a',
  //                 'Broker Fee $': 'broker_fee',
  //                 'Title Fee $': 'title_fee',
  //                 'SUV $': 'suv_fee',
  //                 'Clearance Fee $': 'clearance_fee',
  //                 'Hybrid Fee $': 'hybrid_fee',
  //                 'Heavy Equipment Fee $': 'heavy_equipment_fee',
  //                 'Part Pickup Fee $': 'part_pickup_fee',
  //                 'Relist/Reversal Fee $': 'relist_fee',
  //                 'Misc Fee $': 'misc_fee',
  //                 'Discount $': 'discount_fee',
  //                 'Total $': 'total_amount',
  //                 'S Comment': 'comments',
  //                 'Customer Name': 'customer_name',
  //                 'Customer Code': 'customer_code',
  //             };

  //             const textHeaders = ['S Comment'];

  //             setUploadHeaderMap(headerMap);
  //             setUploadTextHeaders(textHeaders || []);

  //             generateBatchNumber();

  //             const withSerialNumber = jsonData.map((row, index) => ({
  //                 serialNumber: index + 1,
  //                 ...row,
  //             }));

  //             setPreviewExcelData(withSerialNumber);
  //             setExcelPopupOpen(true);

  //         } catch (error) {
  //             ErrorToaster("Failed to read Excel file.");
  //         }
  //     };

  //     if (file.type === "text/csv") {
  //         reader.readAsText(file);
  //     } else {
  //         reader.readAsBinaryString(file);
  //     }
  // };

  const normalize = (v) => (v ?? "").toString().trim().toLowerCase();

  // Build a VIN -> costing index once and reuse it for
  // validation and payload generation to avoid repeated scans
  const vinCostingIndex = useMemo(() => {
    const index = new Map();
    if (!Array.isArray(clientCostingData)) return index;

    clientCostingData.forEach((rec) => {
      const vin = normalize(rec?.booking?.vin);
      if (vin && !index.has(vin)) {
        index.set(vin, rec);
      }
    });

    return index;
  }, [clientCostingData]);

  const rowErrors = useMemo(() => {
    if (!Array.isArray(previewExcelData) || !Array.isArray(clientCostingData))
      return {};

    const vinCounts = previewExcelData.reduce((acc, row) => {
      const v = normalize(row?.VIN ?? row?.Vin ?? row?.vin);
      if (!v) return acc;
      acc[v] = (acc[v] || 0) + 1;
      return acc;
    }, {});
    const dupVINs = new Set(
      Object.keys(vinCounts).filter((v) => vinCounts[v] > 1),
    );

    const errs = {};

    previewExcelData.forEach((row, i) => {
      const rowErrs = [];

      const rowVin = normalize(row?.VIN ?? row?.Vin ?? row?.vin);
      const rowName = normalize(
        row?.["Customer Name"] ??
        row?.customer_name ??
        row?.Customer ??
        row?.Name,
      );

      if (!rowVin) rowErrs.push("VIN is missing");

      if (rowVin && dupVINs.has(rowVin)) {
        rowErrs.push(
          `Duplicate VIN in upload (appears ${vinCounts[rowVin]} times)`,
        );
      }

      const matchingCosting = rowVin ? vinCostingIndex.get(rowVin) : undefined;

      if (matchingCosting) {
        if (matchingCosting?.invoice) {
          if (parseFloat(matchingCosting?.invoice?.paid) > 0) {
            rowErrs.push(
              `Costing cannot be performed for paid vehicle (VIN: ${rowVin})`,
            );
          }
        }
        // if (matchingCosting?.total_v2 !== "0.000" || matchingCosting?.shipping_charges !== "0.000") {
        //     rowErrs.push(`Costing has already been performed for vehicle (VIN: ${rowVin})`);
        // }
      }

      if (rowErrs.length === 0) {
        const byVin = rowVin ? vinCostingIndex.get(rowVin) : undefined;

        if (!byVin) {
          rowErrs.push("VIN not found in system");
        } else {
          if (byVin) {
            const sysLot = normalize(byVin?.booking?.lot_number);
            const sysName = normalize(byVin?.booking?.customer?.name);
            // if (rowLot && sysLot && rowLot !== sysLot) {
            //     rowErrs.push(`VIN & LOT mismatch (system LOT: ${byVin?.booking?.lot_number || "-"})`);
            // }
            // if (rowName && sysName && rowName !== sysName) {
            //     rowErrs.push(`Customer mismatch for VIN (belongs to: ${byVin?.booking?.customer?.name || "-"})`);
            // }
          } else {
            rowErrs.push("VIN not found in system");
          }

          // if (byLot) {
          //     const sysVin = normalize(byLot?.booking?.vin);
          //     const sysName = normalize(byLot?.booking?.customer?.name);
          //     if (rowVin && sysVin && rowVin !== sysVin) {
          //         rowErrs.push(`LOT & VIN mismatch (system VIN: ${byLot?.booking?.vin || "-"})`);
          //     }
          //     if (rowName && sysName && rowName !== sysName) {
          //         rowErrs.push(`Customer mismatch for LOT (belongs to: ${byLot?.booking?.customer?.name || "-"})`);
          //     }
          // } else {
          //     rowErrs.push("LOT not found in system");
          // }
        }
      }

      if (rowErrs.length > 0) errs[i] = rowErrs;
    });

    return errs;
  }, [previewExcelData, clientCostingData]);

  const HIGH_VALUE_VEHICLE_THRESHOLD = 50000;

  const rowWarnings = useMemo(() => {
    if (!Array.isArray(previewExcelData) || !Array.isArray(clientCostingData))
      return {};

    const warns = {};

    previewExcelData.forEach((row, i) => {
      const rowVin = normalize(row?.VIN ?? row?.Vin ?? row?.vin);
      if (!rowVin) return;

      const matchingCosting = vinCostingIndex.get(rowVin);
      if (!matchingCosting) return;

      const vehicleValue =
        parseFloat(matchingCosting?.booking?.value || 0) +
        parseFloat(matchingCosting?.booking?.other_charges || 0);

      if (vehicleValue >= HIGH_VALUE_VEHICLE_THRESHOLD) {
        warns[i] = [
          `This VIN (${rowVin?.toUpperCase()}) is over valued, Please add perform Client Costing manually`,
        ];
      }
    });

    return warns;
  }, [previewExcelData, clientCostingData, vinCostingIndex]);

  const updateExcelFile = async () => {
    setLoading(true);

    try {
      const headerMap = {
        "Customer Name": "customer_name",
        "Customer Code": "customer_id",
        VIN: "vin",
        LOT: "lot_number",
        "Shipping Charges $": "shipping_charges",
        "Auction Late Pmt Fee $": "late_fee",
        "Ship. Late Pmt Fee $": "ship_late_fee",
        "Storage $": "storage",
        "Terminal Storages $": "terminal_storages",
        "Cat A $": "category_a",
        "Broker Fee $": "broker_fee",
        "Title Fee $": "title_fee",
        "SUV $": "current_suv",
        "Clearance Fee $": "clearance_att_fee",
        "Hybrid Fee $": "hybrid_fee",
        "Heavy Equipment Fee $": "heavy_equipment_fee",
        "Part Pickup Fee $": "parts_pickup_fee",
        "Wrapping Fee $": "wrapping_fee",
        "Relist/Reversal Fee $": "relist_reversal_fee",
        "Misc Fee $": "misc_fee",
        "Fuel Surcharge $": "fuel_surcharge",
        "Color Change $": "color_change",
        "THC Charges $": "thc_charges",
        "Intl Clearance $": "intl_clearance",
        "Inland Transportation $": "inland_transportation",
        "INTNL Export Charges $": "intnl_export_charges",
        "Discount $": "discount",
        "War Sur.Char Disc $": "war_surcharge_disc",
        "Total $": "total_costing",
        "S Comment": "notes",

      };

      const rowsToPost = previewExcelData.filter((_, i) => !rowWarnings[i]);

      const filteredBatchTotal = rowsToPost
        .reduce((sum, row) => sum + (parseFloat(row?.["Total $"]) || 0), 0)
        .toFixed(2);

      const payload = {
        batch_number: batchNumber,
        batch_total: filteredBatchTotal,
        costings: rowsToPost.map((row) => {
          const obj = {};

          Object.entries(row).forEach(([key, value]) => {
            const apiKey = headerMap[key];
            if (apiKey) {
              const val = value?.toString().trim();

              if (
                ["customer_id", "booking_id", "costing_id"].includes(apiKey)
              ) {
                obj[apiKey] = !val ? 0 : parseInt(val);
              } else {
                if (!val) {
                  obj[apiKey] = 0;
                } else if (isNaN(val)) {
                  obj[apiKey] = val;
                } else {
                  obj[apiKey] = parseFloat(val);
                }
              }
            }
          });

          // Object.entries(row).forEach(([key, value]) => {
          //     const apiKey = headerMap[key];
          //     if (apiKey) {
          //         const val = value?.toString().trim();
          //         if (["customer_id", "booking_id", "costing_id"].includes(apiKey)) {
          //             obj[apiKey] = val === '' ?  0 : parseInt(val);
          //             // obj[apiKey] = parseInt(val);
          //         } else {
          //             obj[apiKey] = isNaN(val) ? val : parseFloat(val).toFixed(2);
          //         }
          //     }
          // });

          obj.excel_upload = true;
          obj.updated_by = user?.name;
          obj.batch_number = row.batch_number;
          const vin = obj.vin?.toLowerCase().trim();
          const matched = vin ? vinCostingIndex.get(vin) : undefined;
          obj.costing_id = matched?.invoice?.costing_id || null;
          obj.booking_id = matched?.booking_id || 0;
          obj.customer_phone = matched?.booking?.customer?.uae_phone || "";
          obj.customer_id = matched?.booking?.customer?.id || "";
          obj.vehicle_make = matched?.booking?.veh_make?.name || "";
          obj.vehicle_model = matched?.booking?.veh_model?.name || "";
          obj.container_no = matched?.shipping?.container_no || "";
          obj.color = matched?.booking?.color || "";
          obj.country_code = matched?.shipping?.location?.country_code || "US";
          obj.location = matched?.shipping?.location?.city_name || "";
          obj.loading_port = matched?.shipping?.loading_port_id || "";
          obj.destination = matched?.shipping?.dest?.name || "";
          obj.galaxy_arrival_date =
            matched?.vehicle?.arrived_galaxy_date || null;
          obj.port_date = matched?.vehicle?.arrived_port_date || null;
          obj.vat = matched?.invoice?.vat_total || 0;
          obj.custom_duty = matched?.invoice?.custom_total || 0;
          obj.storage = matched?.storage || 0;
          obj.late_fee = matched?.late_fee || 0;
          obj.wrapping_fee = matched?.wrapping_fee || 0;
          obj.discount_aed = parseFloat(obj.discount || 0) * (usdExchangeRate || 0);
          return obj;
        }),
      };

      await ClientServices.updateClientCostingV2(payload);
      setExcelPopupOpen(false);
      getClientCosting();
      window.location.reload();
      SuccessToaster("File updated successfully!");
    } catch (error) {
      ErrorToaster(error?.response?.data?.message || error);
    } finally {
      setLoading(false);
    }
  };

  const totalPreviewRows = previewExcelData?.length || 0;

  const uniqueVinCount = useMemo(() => {
    if (!Array.isArray(previewExcelData)) return 0;
    const seen = new Set();
    previewExcelData.forEach((row) => {
      const vin = (row?.VIN ?? row?.Vin ?? row?.vin ?? "")
        .toString()
        .trim()
        .toLowerCase();
      if (vin) seen.add(vin);
    });
    return seen.size;
  }, [previewExcelData]);

  const downloadExcel = async () => {
    const headers = tableHead.filter(
      (item) => item !== "Checkbox" && item !== "Notes" && item !== "Action",
    );
    const rows = clientCosting?.map((item) => [
      item?.booking?.customer?.ref_id ?? "-",
      item?.booking?.customer?.name ?? "-",
      item?.booking?.purchase_date
        ? moment(item?.booking?.purchase_date).format("DD-MMM-YYYY")
        : "-",
      item?.booking?.buyer?.name ?? "-",
      item?.booking?.veh_model?.name ?? "-",
      item?.booking?.veh_make?.name ?? "-",
      item?.booking?.vin ?? "-",
      item?.booking?.lot_number ?? "-",
      item?.shipping?.loading_port?.name ?? "-",
      item?.shipping?.dest?.name ?? "-",
      item?.shipping?.container_no ?? "-",
      item?.vehicle?.arrived_galaxy_date
        ? moment(item?.vehicle?.arrived_galaxy_date).format("DD-MMM-YYYY")
        : "-",
      item?.shipping_charges === "0"
        ? item?.shipping_placeholder_charges
          ? parseFloat(item?.shipping_placeholder_charges).toFixed(2)
          : parseFloat(0).toFixed(2)
        : (parseFloat(item?.shipping_charges).toFixed(2) ?? "-"),
      parseFloat(item?.late_fee).toFixed(2) ?? "-",
      parseFloat(item?.storage).toFixed(2) ?? "-",
      item?.booking?.buyer?.type == "A" && item?.category_a == 0
        ? parseFloat(item?.category_a).toFixed(2)
        : (parseFloat(item?.category_a).toFixed(2) ?? "-"),
      item?.booking?.buyer?.type == "B" && item?.broker_fee == 0
        ? parseFloat(item?.broker_fee).toFixed(2)
        : (parseFloat(item?.broker_fee).toFixed(2) ?? "-"),
      parseFloat(item?.title_fee).toFixed(2) ?? "-",
      parseFloat(item?.other_charge).toFixed(2) ?? "-",
      parseFloat(
        item?.vehicle?.vcc?.custom_due
          ? item?.custom_duty == 0
            ? item?.vehicle?.vcc?.custom_charges_aed / currencyExchangeRate
            : item?.custom_duty
          : 0,
      ).toFixed(2),
      parseFloat(
        item?.vehicle?.vcc?.vat_due
          ? item?.vat == 0
            ? item?.vehicle?.vcc?.vat_charges_aed / currencyExchangeRate
            : item?.vat
          : 0,
      ).toFixed(2),
      showDue
        ? parseFloat(
          parseFloat(
            totalAmount.find((e) => e?.id === item?.id)?.grand_total,
          ),
        ).toFixed(2)
        : parseFloat(
          totalAmount.find((e) => e?.id === item?.id)?.grand_total,
        ).toFixed(2),
      parseFloat(item?.discount).toFixed(2) ?? "-",
      showDue
        ? parseFloat(
          parseFloat(
            totalAmount.find((e) => e?.id === item?.id)?.grand_total,
          ) -
          parseFloat(totalAmount.find((e) => e?.id === item?.id)?.discount),
        ).toFixed(2)
        : parseFloat(
          parseFloat(
            totalAmount.find((e) => e?.id === item?.id)?.grand_total,
          ) -
          parseFloat(totalAmount.find((e) => e?.id === item?.id)?.discount),
        ).toFixed(2),
    ]);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.addRow(headers);
    rows.forEach((row) => worksheet.addRow(row));

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "data.xlsx");
  };

  useEffect(() => {
    getClientDropdown();
    getCurrencies();
    getDestinations();
  }, []);

  useEffect(() => {
    if (clientCosting.length > 0) {
      const flags = {};
      clientCosting.forEach((item) => {
        flags[item.id] = getTrueDiscountFlags(item);
      });
      setBookingDiscountFlags(flags);
    }
  }, [clientCosting]);

  const headerMap = {
    "Customer Name": "customer_name",
    "Customer Code": "customer_code",
    VIN: "vin",
    LOT: "lot_number",
    "Shipping Charges $": "shipping_charges",
    "Cat A $": "category_a",
    "Broker Fee $": "broker_fee",
    "Title Fee $": "title_fee",
    "SUV $": "current_suv",
    "Clearance Fee $": "clearance_att_fee",
    "Hybrid Fee $": "hybrid_fee",
    "Heavy Equipment Fee $": "heavy_equipment_fee",
    "Part Pickup Fee $": "parts_pickup_fee",
    "Relist/Reversal Fee $": "relist_reversal_fee",
    "Misc Fee $": "misc_fee",
    "Fuel Surcharge $": "fuel_surcharge",
    "Color Change $": "color_change",
    "THC Charges $": "thc_charges",
    "Discount $": "discount",
    "Total $": "total_costing",
    "S Comment": "notes",
  };
  const { done, total } = prefetchProgress || { done: 0, total: 0 };

  return (
    <Fragment>
      <Dialog
        open={excelPopupOpen}
        onClose={() => setExcelPopupOpen(false)}
        fullWidth
        maxWidth={excelDialogMax ? false : "xl"}
        PaperProps={{
          sx: excelDialogMax
            ? {
              width: { xs: "calc(100vw - 10px)", md: "calc(100vw - 20px)" },
              maxWidth: "none",
              height: { xs: "85vh", md: "85vh" },
            }
            : {},
        }}
      >
        <Box sx={{ p: 3, position: "relative" }}>
          {/* Max/Restore */}
          <IconButton
            onClick={() => setExcelDialogMax((m) => !m)}
            sx={{ position: "absolute", right: 56, top: 16, color: "#000" }}
            aria-label={excelDialogMax ? "Restore size" : "Maximize"}
          >
            {excelDialogMax ? (
              <MaximizeIcon style={{ marginTop: "10px" }} />
            ) : (
              <CloseFullscreenIcon />
            )}
          </IconButton>
          {/* Close */}
          <IconButton
            onClick={() => setExcelPopupOpen(false)}
            sx={{ position: "absolute", right: 16, top: 16, color: "#000" }}
          >
            <CancelOutlined />
          </IconButton>

          <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
            Edit Uploaded Excel Data
          </Typography>

          {isUploading && (
            <Box sx={{ textAlign: "center", marginTop: 4 }}>
              <CircularProgress />
              <Typography variant="body1" sx={{ marginTop: 2 }}>
                Uploading file... Please wait.
              </Typography>
            </Box>
          )}
          {!isPrefetchComplete ? (
            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Typography variant="body1">
                Matching VINs… {done}/{total} loaded.
              </Typography>
              <CircularProgress
                variant="determinate"
                value={(done / total) * 100}
              />
            </Box>
          ) : (
            <Typography variant="body1">VIN matching completed!</Typography>
          )}

          {/* Badges: totals */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              mt: 1,
              mb: 1.5,
            }}
          >
            <Box sx={{ px: 1, py: 0.5, borderRadius: "10px" }}>
              <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                Total rows: {totalPreviewRows}
              </Typography>
            </Box>
            <Box sx={{ px: 1, py: 0.5, borderRadius: "10px" }}>
              <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                Total Unique VIN rows: {uniqueVinCount}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              maxHeight: excelDialogMax ? "66vh" : "65vh",
              overflow: "auto",
            }}
          >
            <Table size="small">
              <TableHead sx={{ backgroundColor: "#4ab43e" }}>
                <TableRow>
                  <TableCell
                    sx={{ color: "#ffffff", textAlign: "center", width: 60 }}
                  >
                    Serial Number
                  </TableCell>

                  {previewExcelData.length > 0 &&
                    Object.keys(previewExcelData[0]).map(
                      (key, index) =>
                        key !== "serialNumber" && (
                          <TableCell key={index} sx={{ color: "#ffffff" }}>
                            {headerDisplayName(key)}
                            {/* {key} */}
                          </TableCell>
                        ),
                    )}
                  {previewExcelData.length > 0 && (
                    <TableCell
                      sx={{ color: "#ffffff", textAlign: "center", width: 64 }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {previewExcelData.map((row, rowIndex) => {
                  const isInvalid = !!rowErrors[rowIndex];
                  return (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        backgroundColor: isInvalid ? "#FFF4F4" : undefined,
                      }}
                    >
                      {Object.entries(row).map(([key, value], colIndex) => (
                        <TableCell key={colIndex}>
                          {[
                            "Shipping Charges $",
                            "Auction Late Pmt Fee $",
                            "Ship. Late Pmt Fee $",
                            "Storage $",
                            "Terminal Storages $",
                            "Cat A $",
                            "Broker Fee $",
                            "Title Fee $",
                            "SUV $",
                            "Clearance Fee $",
                            "Hybrid Fee $",
                            "Heavy Equipment Fee $",
                            "Part Pickup Fee $",
                            "Wrapping Fee $",
                            "Relist/Reversal Fee $",
                            "Misc Fee $",
                            "Fuel Surcharge $",
                            "Color Change $",
                            "THC Charges $",
                            "Intl Clearance $",
                            "Inland Transportation $",
                            "INTNL Export Charges $",
                            "Discount $",
                            "War Sur.Char Disc $",
                            "S Comment",
                          ].includes(key) ? (
                            <InputField
                              size="small"
                              type={
                                ["S Comment"].includes(key) ? "text" : "number"
                              }
                              value={value}
                              onChange={(e) =>
                                handleFieldChange(e, rowIndex, key)
                              }
                              // onChange={(e) => {
                              //     const newData = [...previewExcelData];
                              //     newData[rowIndex][key] = e.target.value;

                              //     const mappedRow = {};
                              //     Object.entries(newData[rowIndex]).forEach(([excelKey, val]) => {
                              //         const apiKey = headerMap[excelKey];
                              //         if (apiKey) mappedRow[apiKey] = parseFloat(val || 0);
                              //     });
                              //     newData[rowIndex]["Total $"] = calculateTotal(mappedRow);

                              //     setPreviewExcelData(newData);
                              // }}
                              inputStyle={{ width: "100px" }}
                            />
                          ) : (
                            <Typography variant="body2">{value}</Typography>
                          )}
                        </TableCell>
                      ))}
                      <TableCell sx={{ textAlign: "center" }}>
                        <Tooltip title="Remove row">
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    "Do You Really Want To Remove This row?",
                                  )
                                ) {
                                  setPreviewExcelData((prev) =>
                                    prev.filter((_, i) => i !== rowIndex),
                                  );
                                }
                              }}
                              sx={{
                                color: "red",
                                "&:hover": {
                                  color: "#d32f2f",
                                },
                              }}
                              disabled={loading}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>

          {Object.keys(rowErrors).length > 0 && (
            <Box
              sx={{
                mt: 2,
                p: 1.5,
              }}
            >
              <Typography
                sx={{
                  color: "#D32F2F",
                  fontWeight: 700,
                  mb: 0.5,
                  fontSize: 14,
                }}
              >
                {Object.keys(rowErrors).length} row(s) have errors. Please fix
                them before posting.
              </Typography>
              <Box
                component="ul"
                sx={{
                  m: 0,
                  p: 0,
                  listStyle: "none",
                  color: "#D32F2F",
                  fontSize: 12,
                  display: "inline-block",
                  textAlign: "left",
                }}
              >
                {Object.entries(rowErrors)
                  .slice(0, 6)
                  .map(([idx, errs]) => (
                    <li key={idx}>
                      Row {Number(idx) + 1}: {errs.join(" • ")}
                    </li>
                  ))}
              </Box>
              {Object.keys(rowErrors).length > 6 && (
                <Typography sx={{ color: "#D32F2F", fontSize: 12, mt: 0.5 }}>
                  …and {Object.keys(rowErrors).length - 6} more.
                </Typography>
              )}
            </Box>
          )}

          {Object.keys(rowWarnings).length > 0 && (
            <Box
              sx={{
                mt: 2,
                p: 1.5,
              }}
            >
              <Typography
                sx={{
                  color: "#D32F2F",
                  fontWeight: 700,
                  mb: 0.5,
                  fontSize: 14,
                }}
              >
                {Object.keys(rowWarnings).length} row(s) will be skipped (over
                valued vehicles):
              </Typography>
              <Box
                component="ul"
                sx={{
                  m: 0,
                  p: 0,
                  listStyle: "none",
                  color: "#D32F2F",
                  fontSize: 12,
                  display: "inline-block",
                  textAlign: "left",
                }}
              >
                {Object.entries(rowWarnings).map(([idx, warns]) => (
                  <li key={idx}>
                    Row {Number(idx) + 1}: {warns.join(" • ")}
                  </li>
                ))}
              </Box>
            </Box>
          )}

          {/* Footer */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <PrimaryButton
              variant="contained"
              onClick={updateExcelFile}
              disabled={
                loading ||
                Object.keys(rowErrors).length > 0 ||
                Object.keys(rowWarnings).length >= previewExcelData.length
              }
              sx={{
                textTransform: "capitalize",
                backgroundColor: Colors.primary,
                "&:hover": { backgroundColor: Colors.primaryDark },
                width: "150px",
                padding: "10px",
                border: "1px solid #4CAF50",
              }}
              title={loading ? "Posting..." : "Post"}
            />
          </Box>
        </Box>
      </Dialog>
      <Dialog
        open={excelsPopupOpen}
        onClose={() => setExcelsPopupOpen(false)}
        fullWidth
      // maxWidth={excelDialogMax ? false : "xl"}
      // PaperProps={{
      //     sx: excelDialogMax
      //         ? {
      //             width: { xs: "calc(100vw - 10px)", md: "calc(100vw - 20px)" },
      //             maxWidth: "none",
      //             height: { xs: "85vh", md: "85vh" },
      //         }
      //         : {},
      // }}
      >
        <Box sx={{ p: 3, position: "relative" }}>
          {/* Max/Restore */}

          {/* Close */}
          <IconButton
            onClick={() => setExcelsPopupOpen(false)}
            sx={{ position: "absolute", right: 16, top: 16, color: "#000" }}
          >
            <CancelOutlined />
          </IconButton>

          <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
            Edit Uploading Excel Data
          </Typography>

          {isUploading && (
            <Box sx={{ textAlign: "center", marginTop: 4 }}>
              <CircularProgress
                variant={
                  isPrefetching && total > 0 ? "determinate" : "indeterminate"
                }
                value={
                  isPrefetching && total > 0 ? (done / total) * 100 : undefined
                }
              />
              <Typography variant="body1" sx={{ marginTop: 2 }}>
                {isPrefetching
                  ? total > 0
                    ? `Loading data… ${done}/${total} records loaded.`
                    : "Loading data… please wait."
                  : "Uploading file... Please wait."}
              </Typography>
            </Box>
          )}
        </Box>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Typography
          sx={{
            p: 3,
            px: 5,
            fontSize: 17,
            fontFamily: FontFamily.openSans,
            fontWeight: "bold",
          }}
          id="alert-dialog-title"
        >
          {"Are You Sure You Want To Delete Shipping Costing?"}
        </Typography>

        <Grid item xs={12} sm={12} sx={{ mb: 2, textAlign: "center" }}>
          <PrimaryButton
            title="No"
            type="button"
            buttonStyle={{ minWidth: "120px" }}
            onClick={() => setOpenDeleteModal(false)}
          />
          <Box component={"span"} sx={{ mx: 1 }} />
          <PrimaryButton
            title="Yes"
            type="button"
            bgcolor={Colors.danger}
            buttonStyle={{
              minWidth: "120px",
              "&:hover": { backgroundColor: Colors.danger },
            }}
            onClick={handleDelete}
          />
        </Grid>
      </Dialog>

      <Dialog
        open={vDialogOpen}
        onClose={handleCloseDialog}
        sx={{
          "& .MuiDialog-paper": {
            width: "30%",
            height: "auto",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>
        <Box component={"form"}>
          <InputField
            disabled={true}
            label={noteHeading}
            error={errors?.notes?.message}
            register={register("vNote", {
              // required: "Please enter notes.",
            })}
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <PrimaryButton
              type="button"
              onClick={handleCloseDialog}
              title="Close"
            />
          </Box>
        </Box>
      </Dialog>
      <CostingDialog
        open={costingDialogOpen}
        readOnly={false}
        onClose={() => {
          setSelectedClientBooking([]);
          setSelectedContainer(null);
          setCostingDialogOpen(false);
        }}
        containerData={{ container_no: selectedContainer }}
        costings={selectedVehicles}
        currencyExchangeRate={currencyExchangeRate}
        navigate={navigate}
        selectedClient={selectedClient}
        setSelectedClientBooking={setSelectedClientBooking}
        findDifferences={findDifferences}
        getClientCosting={getClientCosting}
        copyClientCosting={copyClientCosting}
        selectedClientBooking={selectedClientBooking}
        handleCalc={handleCalc}
        updateClientCosting={updateClientCosting}
        savedData={savedData}
        setSavedData={setSavedData}
        setSelectedContainer={setSelectedContainer}
        bookingDiscountFlags={bookingDiscountFlags}
      />
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {/* //*Dialog Box */}
        <Box>
          <EditNotes
            item={tableId}
            open={isDialogOpen}
            onClose={handleCloseDialog}
          />
        </Box>

        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mr: 4,
              my: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Client Shipping CostingV2
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                onClick={handleDownloadExcelFormat}
                sx={{
                  textTransform: "capitalize",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                  minWidth: { xs: "150px", md: "180px" },
                  py: 1.2,
                  fontSize: { xs: 12, md: 14 },
                  backgroundColor: "#ffffff",
                  color: "black",
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  "&:hover": {
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                    backgroundColor: "#f9f9f9",
                  },
                  marginRight: "10px",
                }}
              >
                {" "}
                Download Excel Format{" "}
              </Button>
              {clientCosting?.length > 0 && (
                <>
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    ref={fileInputRef}
                    onChange={handleFileUploadPreview}
                    style={{ display: "none" }}
                  />

                  <Button
                    onClick={() => fileInputRef.current.click()}
                    startIcon={<UploadFile />}
                    sx={{
                      textTransform: "capitalize",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                      minWidth: { xs: "100px", md: "150px" },
                      py: 1.2,
                      fontSize: { xs: 12, md: 14 },
                      backgroundColor: "#ffffff",
                      color: "black",
                      border: "1px solid #ddd",
                      borderRadius: "12px",
                      "&:hover": {
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                        backgroundColor: "#f9f9f9",
                      },
                      marginRight: "10px",
                    }}
                  //  disabled={isPrefetching || !isPrefetchComplete}
                  >
                    Upload Excel
                  </Button>
                </>
              )}

              {clientCosting?.length > 0 && (
                <>
                  <Button
                    onClick={() => downloadExcel()}
                    sx={{
                      textTransform: "capitalize",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                      minWidth: { xs: "100px", md: "150px" },
                      py: 1.2,
                      fontSize: { xs: 12, md: 14 },
                      backgroundColor: "#ffffff",
                      color: "black",
                      border: "1px solid #ddd",
                      borderRadius: "12px",
                      "&:hover": {
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                  >
                    Download Excel
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item md={11}>
          <Box
            sx={{
              m: "10px 0 10px 0",
              // p: "20px",
              // bgcolor: Colors.feta,
              // border: `1px solid ${Colors.iron}`,
              // borderRadius: "9px",
            }}
          >
            <Grid
              container
              spacing={1}
              alignItems={"center"}
              component={"form"}
              onSubmit={handleSubmit(applyFilter)}
            >
              <Grid item xs={12} md={3}>
                <InputField
                  size={"small"}
                  // inputStyle={{ backgroundColor: "#f5f5f5" }}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search", {
                    // onChange: (e) => applyFilter(e?.target?.value)
                  })}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <SelectField
                  size="small"
                  label={"Customer"}
                  options={clients}
                  selected={selectedClient}
                  onSelect={(value) => {
                    setSelectedClient(value);
                  }}
                  error={errors?.vendor?.message}
                  register={register("client")}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <SelectField
                  size="small"
                  label={"Destination"}
                  options={destinations}
                  selected={selectedDestination}
                  onSelect={(value) => {
                    setSelectedDestination(value);
                  }}
                  onSearch={(v) => getDestinations(v)}
                  register={register("destination")}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    mt: "12px",
                  }}
                >
                  <PrimaryButton title={"Search"} type={"submit"} />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "10px",
                }}
              >
                {clientCosting.length > 0 && (
                  <FormControl>
                    <InputLabel>Columns</InputLabel>
                    <Select
                      size={"small"}
                      multiple
                      value={visibleColumns}
                      label={"Columns"}
                      onChange={handleColumnChange}
                      renderValue={() => "Show/Hide"}
                      sx={{ borderRadius: "12px !important" }}
                    >
                      {tableHead.map((column, index) => {
                        if (
                          column !== "Checkbox" &&
                          column !== "SHIPPING CHARGE" &&
                          column !== "LATE FEE" &&
                          column !== "STORAGE" &&
                          column !== "CATEGORY A" &&
                          column !== "BROKER FEE" &&
                          column !== "TITLE FEE" &&
                          column !== "OTHER CHARGE" &&
                          column !== "CUSTOM DUTY" &&
                          column !== "VAT" &&
                          column !== "TOTAL SHIPPING" &&
                          column !== "DISCOUNT" &&
                          column !== "NET DUE AMOUNT" &&
                          column !== "Notes" &&
                          column !== "OTHER CHARGES"
                        ) {
                          return (
                            <MenuItem key={index} value={index}>
                              <Checkbox
                                checked={visibleColumns.includes(index)}
                              />
                              <ListItemText primary={column} />
                            </MenuItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item md={11}>
          {clientCosting.length > 0 && (
            <Box>
              {/* <Grid container mb={2}>
                                <Grid item xs={5}>
                                    <FormControl>
                                        <InputLabel>Columns</InputLabel>
                                        <Select
                                            size={"small"}
                                            multiple
                                            value={visibleColumns}
                                            label={"Columns"}
                                            onChange={handleColumnChange}
                                            renderValue={() => "Show/Hide"}
                                        >
                                            {tableHead.map((column, index) => {
                                                if (
                                                    column !== "Checkbox" &&
                                                    column !== "SHIPPING CHARGE" &&
                                                    column !== "LATE FEE" &&
                                                    column !== "STORAGE" &&
                                                    column !== "CATEGORY A" &&
                                                    column !== "BROKER FEE" &&
                                                    column !== "TITLE FEE" &&
                                                    column !== "OTHER CHARGE" &&
                                                    column !== "CUSTOM DUTY" &&
                                                    column !== "VAT" &&
                                                    column !== "TOTAL SHIPPING" &&
                                                    column !== "DISCOUNT" &&
                                                    column !== "NET DUE AMOUNT" &&
                                                    column !== "Notes" &&
                                                    column !== "OTHER CHARGES"
                                                ) {
                                                    return (
                                                        <MenuItem key={index} value={index}>
                                                            <Checkbox
                                                                checked={visibleColumns.includes(index)}
                                                            />
                                                            <ListItemText primary={column} />
                                                        </MenuItem>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid> */}

              {loader ? (
                <CircularProgress />
              ) : (
                clientCosting.length > 0 && (
                  <TableContainer
                    component={Paper}
                    sx={{
                      boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                      borderRadius: 2,
                      maxHeight: "calc(100vh - 330px)",
                    }}
                  >
                    <Table stickyHeader sx={{ minWidth: 500 }}>
                      {/* Table Header */}
                      <TableHead>
                        <TableRow>
                          {visibleColumns.map((index) => (
                            <Cell
                              key={index}
                              sx={{
                                bgcolor: `${index < 10 ? Colors.primary : Colors.blue
                                  } !important`,
                                maxWidth:
                                  tableHead[index].length > 10
                                    ? "200px"
                                    : "auto",
                              }}
                            >
                              {tableHead[index]}
                            </Cell>
                          ))}
                        </TableRow>
                      </TableHead>

                      {/* Table Body */}
                      <TableBody>
                        {!loader ? (
                          clientCosting?.length > 0 ? (
                            <Fragment>
                              {clientCosting.map((item, rowIndex) => {
                                const isActive =
                                  selectedClientBooking.indexOf(item?.id) !==
                                  -1;
                                const isSelected =
                                  selectedClientBooking.includes(item.id);
                                return (
                                  <Row
                                    key={rowIndex}
                                    sx={{
                                      bgcolor: rowIndex % 2 !== 0 && "#EFF8E7",
                                    }}
                                  >
                                    {visibleColumns.map((colIndex) => {
                                      const columnName = tableHead[colIndex];
                                      return (
                                        <Cell
                                          key={colIndex}
                                          onDoubleClick={() => {
                                            if (
                                              isSelected &&
                                              columnName !== "DISC $"
                                            ) {
                                              setCostingDialogOpen(true);
                                            }
                                          }}
                                        >
                                          {renderCellContent(
                                            colIndex,
                                            item,
                                            isActive,
                                          )}
                                        </Cell>
                                      );
                                    })}
                                  </Row>
                                );
                              })}
                            </Fragment>
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={visibleColumns.length + 1}
                                align="center"
                                sx={{ fontWeight: 600 }}
                              >
                                No Data Found
                              </TableCell>
                            </TableRow>
                          )
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={visibleColumns.length + 2}
                              align="center"
                              sx={{ fontWeight: 600 }}
                            >
                              <Box className={classes.loaderWrap}>
                                <CircularProgress />
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )
              )}

              {/* Pagination */}
              {clientCosting.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  pageSize={pageLimit}
                  onPageSizeChange={(size) =>
                    getClientCosting(1, size.target.value)
                  }
                  tableCount={clientCosting?.length}
                  totalCount={totalCount}
                  onPageChange={(page) => getClientCosting(page, "")}
                />
              )}
            </Box>
          )}
        </Grid>
        {clientCosting.length > 0 && (
          <>
            {wrongVins.length > 0 && (
              <Grid item md={11}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",

                    gap: "20px",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 700,
                      fontFamily: FontFamily.NunitoRegular,
                      color: "red",
                    }}
                  >
                    {wrongVins.length > 1 ? "Vins" : "Vin"}{" "}
                    {wrongVins.join(",")} Costing Amount{" "}
                    {wrongVins.length > 1 ? "are" : "is"} Less than Paid Amount
                  </Typography>
                </Box>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Fragment>
  );
}

export default ShippingCostingV2;
